import { QUESTIONNAIRE_TEMPLATE_DETAILS } from "../_constants/questionnaireTemplateDetails.constant"

const initialState = {
  loadingTemplateDetails: false,
  templateDetails: {},  
}

export function questionnaireTemplateDetailsReducer(state = initialState, action) {
  switch (action.type) {

    case QUESTIONNAIRE_TEMPLATE_DETAILS.SET_LOADING_TEMPLATE_DETAILS:
      return { ...state, loadingTemplateDetails: action.data }

    case QUESTIONNAIRE_TEMPLATE_DETAILS.SET_TEMPLATE_DETAILS_DATA:
      return {
        ...state,
        templateDetails: {
          ...state.templateDetails,
          [action.version]: action.data   
        },
        loadingTemplateDetails: false
      }

    case QUESTIONNAIRE_TEMPLATE_DETAILS.CLEAR:
      return initialState

    default:
      return state
  }
}
